<template>
  <div class="navbar">
    <NavBar />

    <div class="left-sidebar">
      <div class="admincard">
        <div class="admin">
          <div class="account">
            <h4>ACCOUNT-ADMIN</h4>
          </div>
          <h3>
            &#x1F44B; Welcome Back,<span style="color:blueviolet;">
              {{ userProfile.full_name }}</span
            >
          </h3>
          <p style="font-weight: normal">{{ formattedDate }}</p>
        </div>

        <div class="wallet">
          <strong>Wallet Balance</strong>
          <h2>&#8377; {{ amount }}</h2>
          <h4>
            Running low? <a style="color: deeppink" href="">Click here</a> to
            add moral
          </h4>
        </div>

        <div class="activities">
          <h3>Recent Activities</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import moment from "moment"; // Import moment

export default {
  components: { NavBar },
  name: "LeftSidebar",

  data() {
    return {
      userProfile: {},
      currentDate: new Date(),
      amount: 70.0,
    };
  },

  computed: {
    formattedDate() {
      // Use moment to format the date in DMY format
      return moment(this.currentDate).format("D MMMM YYYY - dddd");
    },
  },

  methods: {
    fetchUserProfile() {
      const profileData = localStorage.getItem("profileData");
      if (profileData) {
        this.userProfile = JSON.parse(profileData);
      }
    },
  },

  created() {
    this.fetchUserProfile();
  },
};
</script>

<style scoped>
.left-sidebar {
  width: 450px;
  height: 880px;
  background-color: rgb(244, 244, 244);
  color: black;
  padding: 5px;
  box-sizing: border-box;
  margin-top: 0px;
  width: 100vw; /* Ensures the container takes the full width of the viewport */
  overflow-x: hidden; /* Hides horizontal overflow */
}

.admin {
  width: 400px;
  background-color: white;
  padding: 10px;
  border-radius: 10px;
  text-align: center;
  margin: 10px;
  margin-top: 65px;
  font-family: "Poppins", sans-serif;
}

.account {
  align-content: center;
  text-align: center;
  margin-left: 136px;
}

.account h4 {
  border: 1px solid rgb(244, 244, 244);
  border-radius: 10px;
  padding: 0.5px;
  width: 160px;
  text-align: center;
  background-color: rgb(244, 244, 244);
}

.wallet {
  width: 400px;
  background-color: white;
  padding-left: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 5px;
  border-radius: 10px;
  margin: 10px;
  text-align: left;
  font-family: sans-serif, monteserrat;
  font-weight: lighter;
}

.activities {
  width: 400px;
  height: 450px;
  background-color: white;
  margin: 10px;
  border-radius: 10px;
  text-align: left;
  padding: 10px;
  font-family: sans-serif, monteserrat;
}

h4 {
  font: medium;
}
</style>
